import * as React from "react";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import Swal from "sweetalert2";

import { loginAlert } from "../../AlertComponent";

const CommentImageUpload = ({
	imageList,
	setImageList,
	photoList,
	setPhotoList,
	comLoading,
}) => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	const isLoading = useSelector((state) => state.common.loading);

	const inputRef = useRef(null);

	/**
	 * 프론트 내 업로드 진행
	 * @param e
	 */
	const onUploadImage = (e) => {
		if (!e.target.files) {
			return;
		}
		const fileList = e.target.files;
		const urlList = [...imageList];
		const photoInfoList = [...photoList];
		for (let i = 0; i < fileList?.length; i++) {
			const fileUrl = URL?.createObjectURL(fileList[i]);
			urlList.push(fileUrl);
			photoInfoList.push({
				file: fileList[i],
				source: fileUrl,
				type: fileList[i]?.type,
			});
		}
		// 최대 1개까지
		setImageList(urlList?.slice(0, 1));
		setPhotoList(photoInfoList?.slice(0, 1));
	};

	return (
		<button
			className={`secret-button-wrap is_secret`}
			style={{
				marginRight: "5px",
				marginLeft: 0,
				backgroundColor: "inherit",
				padding: 0,
				display: "flex",
				alignItems: "center",
				gap: "3px",
			}}
			onClick={() => {
				if (cUser?.id) {
					if (!inputRef.current) {
						return;
					}
					if (imageList?.length < 1) {
						inputRef.current.click();
					} else {
						Swal.fire({
							customClass: "alert-custom",
							text: "이미지는 최대 1장까지 가능합니다",
							confirmButtonText: "확인",
						});
					}
				} else {
					loginAlert({ history, reduxChannel });
				}
			}}
			disabled={comLoading}
		>
			<img
				src={`/assets/images/channel/photo.png`}
				alt={`사진 업로드`}
				style={{
					height: "auto",
					width: "1.2em",
				}}
			/>
			사진
			<input
				type="file"
				// multiple="multiple"
				accept="image/*"
				style={{
					display: "none",
				}}
				ref={inputRef}
				onChange={onUploadImage}
				disabled={isLoading}
			/>
		</button>
	);
};
export default CommentImageUpload;
